import React from "react";
import img5 from './images/superfriends.jpg';

export default function Superfriends() {
    return(
        <div>
        <img src={img5} alt="yes our team is the Super Friends" />
        </div>
    );
}